import React from 'react';
import { FilePreviewListSC } from './file-preview.styled';

interface FilePreviewListProps
  extends Omit<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    'ref'
  > {
  children?: React.ReactNode;
}

const FilePreviewList: React.FunctionComponent<FilePreviewListProps> = ({ children, ...rest }) => {
  return <FilePreviewListSC {...rest}>{children}</FilePreviewListSC>;
};

export default FilePreviewList;
